export const WatermarkedFileModal: string = 'WatermarkedFileModal';
